import { useQuery } from '@tanstack/react-query';
import automateAxios from '../../../utils/automateAxios';
import { QueryKeys } from '../../querys/querys.enum';
import { AutomationLanguageInfo } from '../../../models/Interface/Automation.interface';

const fetchLanguages = async (): Promise<AutomationLanguageInfo[]> => {
  const response = await automateAxios.get<AutomationLanguageInfo[]>('/languages');
  return response.data;
};

const useAutomationLanguages = () => {
  return useQuery<AutomationLanguageInfo[]>({
    queryKey: [QueryKeys.AUTOMATION_LANGUAGES],
    queryFn: fetchLanguages,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    staleTime: 1000 * 60 * 30,
    retry: 2,
  });
};

export default useAutomationLanguages;
